import react from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import './loginStyle.css'
import { constants } from '../../util'
import { useSelector, useDispatch } from 'react-redux';
import { showLogin, showSignup, showPasswordRecovery, showWaiting } from '../../store/slices/configSlice';

import { useTranslation } from 'react-i18next';
import i18next from 'i18next'

import GoogleSignIn from '../../components/auth/GoogleSignIn';
import { setAuthenticated, setProfilePhoto, setIsFullProfile, setIsFirstAccess } from '../../store/slices/userSlice';

import { useNavigate } from 'react-router-dom';
import { login, loginWithGoogle } from '../../services/securityService';
import { jwtDecode } from 'jwt-decode';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'

import { enqueueSnackbar } from 'notistack';

import { GoogleOAuthProvider, GoogleLogin } from '@react-oauth/google';


const Root = styled('div')(({ theme }) => ({
    width: '100%',
    ...theme.typography.body2,
    color: (theme.vars || theme).palette.text.secondary,
    '& > :not(style) ~ :not(style)': {
        marginTop: theme.spacing(2),
    },
}));



const handleSuccess = async (credentialResponse) => {
    try {
        const response = await fetch('/api/auth/google-login', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token: credentialResponse.credential }),
        });

        const data = await response.json();
        // localStorage.setItem('token', data.token); // Guarda el token JWT
        window.location.href = '/dashboard'; // Redirige al dashboard
    } catch (error) {
        console.error("Error en autenticación:", error);
    }
}


export default function Login() {
    //TRANSLATION
    const [t, i18n] = useTranslation("global");


    const sch = (yup) => yup.object({
        email: yup.string().email().required(),
        password: yup.string().required().min(6).max(20),
    });
    const schema = useYupSchema(sch);


    const {openLogin, language, googleClientId} = useSelector( state => state.configuration);
    const {userLogged, profilePhoto} = useSelector( state => state.userLogged);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    

    const handleClick_Signup = () => {
        dispatch(showLogin(false));
        reset();
        dispatch(showSignup(true));
    }
  
    const handleClick_PasswordRecovery = () => {
        dispatch(showLogin(false));
        reset();
        dispatch(showPasswordRecovery(true))
    }


    const { register, handleSubmit, reset, formState: { errors } } = useForm({
        resolver: yupResolver(schema),
    });
    
    const onSubmit = (data) => {
        dispatch(showWaiting(true));
        login(data.email, data.password)
            .then(rsp => {
                if (rsp.code === '00'){
                    dispatch(setAuthenticated(rsp.metadata?.token));
                    reset();

                    setTimeout(() => {
                        dispatch(setProfilePhoto(rsp.metadata?.profilePhoto));
                        dispatch(setIsFullProfile(rsp.metadata?.isFullProfile));
                        dispatch(setIsFirstAccess(rsp.metadata?.isFirstAccess));
                        dispatch(showLogin(false));
                        
                        navigate('/index');

                        setTimeout(() => {
                            enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                            dispatch(showWaiting(false));
                        }, 500);
                    }, 1000);
                }
                else{
                    dispatch(showWaiting(false));
                    enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                }
            });
    }


    return(
        <>
            <Modal
                open={openLogin}
                onClose={()=>{reset(); dispatch(showLogin(false))}}
            >
                <Box sx={{ ...constants.styles.modalBox,
                    width: {
                        sxs: '95%', 
                        xs: '95%',  // Celular-vertical
                        sm: '80%',  // Ipad Vertical
                        md: '50%',  // Ipad Horizontal
                        lg: '65%',  // Laptop-PC
                        xl: '65%',  // Laptop-PC,
                    },
                    maxwidth: {
                        sxs: '400px', 
                        xs: '400px',  // Celular-vertical
                        sm: '50vw',  // Ipad Vertical
                        md: '700px',  // Ipad Horizontal
                        lg: '700px',  // Laptop-PC
                        xl: '700px',  // Laptop-PC,
                    },
                    height:  '95%',
                    minHeight: '350px',
                    maxHeight: '520px',
                
                    // backgroundColor:{
                    //     sxs: 'purple',
                    //     xs: 'pink',
                    //     sm: 'green',
                    //     md: 'red',
                    //     lg: 'blue',
                    //     xl: 'brown'
                    // }
                        
                }}
                >
                    <Grid container spacing={0} sx={{height: '100%'}}>
                        <Grid size={{sxs: 0, xs:0, sm:5, md:5, lg:5, xl:5}} 
                            sx={{ 
                                display: {sxs: 'none', xs:'none', sm:'block', md:'block', lg:'block', xl:'block'},
                                height: '100%',
                                //backgroundImage: "url('/assets/img/generic/guitar-01.svg')",
                                backgroundImage: "url('/assets/img/generic/tololoche2.jpg')",
                                backgroundRepeat: "no-repeat",
                                backgroundPosition: "center",
                                backgroundSize: "cover",
                                borderTopLeftRadius: 12,
                                borderBottomLeftRadius: 12
                            }}
                        >
                        </Grid>
                        
                        <Grid container direction="column" spacing={0} size={{sxs:12, xs:12, sm:7, md:7, lg:7, xl:7}} 
                            sx={{
                                paddingLeft: '25px',
                                paddingRight: '25px',
                                paddingTop: '15px',
                                paddingBottom: '15px',
                                height: '100%',
                                display: 'flex',
                                alignItems: "center",
                            }}
                        >
                            <div style={{width: '100%', maxHeight: '100%', overflow: 'auto'}}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '20px'}}>
                                        <img src="/assets/img/logo/logo-black.svg" style={{width: '150px'}} />
                                    </Grid>
                                    <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '0px'}}>
                                        <TextField 
                                            id="txtMail" 
                                            variant="outlined" 
                                            label={t("login.email")} 
                                            fullWidth
                                            margin="normal" 
                                            sx={{...constants.styles.textfield}}
                                            autoFocus
                                            type='email'
                                            {...register('email')}
                                            error={!!errors.email}
                                            helperText={errors.email?.message}
                                    />
                                        <TextField 
                                            id="txtPassword" 
                                            label={t("login.password")} 
                                            type="password" 
                                            autoComplete="current-password" 
                                            variant="outlined" 
                                            margin="normal" 
                                            fullWidth
                                            {...register('password')}
                                            error={!!errors.password}
                                            helperText={errors.password?.message}
                                        />
                                    </Grid>
                                    <Grid container direction={'column'} size={12} sx={{alignContent: 'flex-end', marginBottom: '10px'}}>
                                        <Button variant="text" sx={{ ...constants.styles.linkButton, fontSize: '11px' }} onClick={()=>handleClick_PasswordRecovery()}>{t("login.forgetPassword")}</Button>
                                    </Grid>
                                    <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '20px'}}>
                                        <Button 
                                            variant="text"
                                            type='submit'
                                            sx={{ ...constants.styles.mainButton }} 
                                        >{t("login.signIn_button")}</Button>
                                    </Grid>
                                </form>
                                <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '15px'}}>
                                    <Root style={{fontSize:'11px'}}>
                                        <Divider>{t("login.otherSignInMethod")}</Divider>
                                    </Root>
                                </Grid>
                                <Grid container direction={'column'} size={12} sx={{alignContent: 'center', marginBottom: '20px'}}>
                                    {/* <Button variant="text" sx={{ ...constants.styles.mainButton, width: '50%', backgroundColor: '#FFFFFF' }}>
                                        <img src='/assets/img/generic/google.png' style={{width: '35px'}} />
                                        {t("login.googleButton")}
                                    </Button> */}
                                    
                                    <GoogleOAuthProvider clientId={googleClientId}>
                                        <GoogleLogin
                                            onSuccess={credentialResponse => {
                                                dispatch(showWaiting(true));
                                                loginWithGoogle(JSON.stringify(credentialResponse))
                                                    .then(rsp => {
                                                        if (rsp.code === '00'){
                                                            dispatch(setAuthenticated(rsp.metadata?.token));
                                                            reset();

                                                            setTimeout(() => {
                                                                dispatch(setProfilePhoto(rsp.metadata?.profilePhoto));
                                                                dispatch(setIsFullProfile(rsp.metadata?.isFullProfile));
                                                                dispatch(setIsFirstAccess(rsp.metadata?.isFirstAccess));
                                                                dispatch(showLogin(false));
                                                                
                                                                navigate('/index');
                                                                
                                                                setTimeout(() => {
                                                                    enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                                                                    dispatch(showWaiting(false));
                                                                }, 500);
                                                            }, 1000);
                                                        }
                                                        else{
                                                            dispatch(showWaiting(false));
                                                            enqueueSnackbar(rsp.message, { variant: 'error', persist: false });
                                                        }
                                                    });
                                                
                                            // Envía el token a tu backend para verificación
                                            }}
                                            onError={() => {
                                                console.log('Login Failed');
                                            }}
                                            // useOneTap
                                            uxMode="redirect"
                                            locale={language}
                                        />
                                    </GoogleOAuthProvider>
                                </Grid>
                                <Grid container direction={'row'} size={12} sx={{alignContent: 'center'}}>
                                    <Grid container direction={'column'} size={6} sx={{paddingTop:'10px'}}>
                                        <Root style={{fontSize:'11px', textAlign:'right'}}> 
                                            {t("login.member")}
                                        </Root>
                                    </Grid>
                                    <Grid container direction={'column'} size={6} sx={{alignContent: 'flex-start'}}>
                                        <Button variant="text" sx={{ ...constants.styles.linkButton, fontWeight: 'bold' }} onClick={()=>handleClick_Signup()}>{t("login.register")}</Button>
                                    </Grid>
                                </Grid>
                                
                                <GoogleSignIn />
                                
                                
                                
                                
                                {/* <div class="g-signin2" data-width="300" data-height="200" data-longtitle="true" /> */}
                            
                            
                            </div>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    )
}
